<template>
  <div id="app">
    <MainNav v-model="parentValue" />
    <transition name="fade">
      <Main v-if="parentValue === 'main'" msg="Mary E. Ellis"/>
    </transition>
    <transition name="fade">
      <Hiring v-if="parentValue === 'hiring'"/>
    </transition>
    <transition name="fade">
      <Contact v-if="parentValue === 'contact'"/>
    </transition>
  </div>
</template>

<script>
import Main from './components/Main.vue'
import MainNav from './components/MainNav'
import Contact from './components/Contact'
import Hiring from './components/Hiring'

export default {
  name: 'App',
  components: {
    Main,
    MainNav,
    Hiring,
    Contact
  },
  data() {
    return {
      parentValue: 'main'
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:wght@500&display=swap');
#app {
  font-family: 'Source Code Pro', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 10px auto 60px;
  max-width: 630px;
}
a {
  color: #ff0000;
}
.fade-enter-active{
  transition: opacity 1.5s;
}
.fade-leave-active {
  opacity: 0;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
